"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/MembersTab/UserItem.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);






var _org = require('shared/selectors/org');
var _peers = require('shared/selectors/peers');
var _user = require('shared/selectors/user');



var _entities = require('shared/transforms/entities');

var _hooks = require('web/services/hooks');

var _UserTile = require('./components/UserTile'); var _UserTile2 = _interopRequireDefault(_UserTile);














const UserItem = ({
  orgKey,
  userKey,
  onEditUser,
  onRemoveUser,
  onApproveUser,
  onRejectUser,
  onResendUserInvite,
  onGotoUser,
  lock,
  onOpenAccountPerson,
}) => {
  const org = _hooks.useAppSelector.call(void 0, state => _org.selectOrgByKey.call(void 0, orgKey, state))
  const user = _hooks.useAppSelector.call(void 0, state => _peers.selectUserV2ByKey.call(void 0, state, userKey))
  const isMe = _hooks.useAppSelector.call(void 0, state => _user.selectCurrentUserKey.call(void 0, state) === userKey)
  const userEntity = _react.useMemo.call(void 0, 
    () => {
      // SAFETY: the one key is orgKey, and its value is the org stored under it.
      const orgsMap = org ? { [orgKey]: org }  : {}
      return !user
        ? null
        : _entities.mapUserToEntity.call(void 0, 
          orgsMap, _entities.makeSpecificOrgTitleUserDescription.call(void 0, orgKey),
        )(user)
    },
    [org, orgKey, user],
  )

  if (!userEntity) return null

  return (
    _react2.default.createElement(_UserTile2.default, {
      orgKey: orgKey,
      entity: userEntity,
      isMe: isMe,
      onEdit: onEditUser,
      onRemove: onRemoveUser,
      onApprove: onApproveUser,
      onReject: onRejectUser,
      onResendInvite: onResendUserInvite,
      onGotoUser: onGotoUser,
      lock: lock,
      onOpenAccountPerson: onOpenAccountPerson, __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
    )
  )
}

exports. default = _react.memo.call(void 0, UserItem)
